/**
 * Created by Arif Topcu in 2019
 */

import React, { memo, useMemo } from "react";
import PropTypes from "prop-types";
import Combobox from "@ls/react-combobox-grid";
import { selectPeriodOptions, selectTypeOptions } from "state/cf/selectors";
import { useSelector } from "react-redux";
import { Cell, Grid } from "styled-css-grid";

const CashFlowSelectorComplication = ({ setDefinition, definition }) => {
  const periodOptions = useSelector(selectPeriodOptions);
  const typeOptions = useSelector(selectTypeOptions);

  const [setPeriod, setType] = useMemo(() => {
    return [
      (value) => setDefinition(definition.setPeriod(value)),
      (value) => setDefinition(definition.setType(value)),
    ];
  }, [definition, setDefinition]);

  return (
    <Grid columns={2} gap={"4px"}>
      <Cell>
        <Combobox
          label="Period:"
          labelPosition={"TOP"}
          value={definition.period}
          options={periodOptions}
          placeholder="Select Period..."
          onChange={setPeriod}
          gridHeight={100}
          clearable={false}
          size={"S"}
          variation={0}
        />
      </Cell>
      <Cell>
        <Combobox
          label="Type:"
          labelPosition={"TOP"}
          value={definition.type}
          options={typeOptions}
          placeholder="Select Type..."
          onChange={setType}
          gridHeight={100}
          clearable={false}
          size={"S"}
          variation={0}
        />
      </Cell>
    </Grid>
  );
};

CashFlowSelectorComplication.propTypes = {
  setDefinition: PropTypes.func.isRequired,
  definition: PropTypes.object.isRequired,
};

export default memo(CashFlowSelectorComplication);
